module.exports = __webpack_public_path__ + "static/media/announcement-confirmation.c08c3550.svg";